/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_PriceInputs */

const et_plan_visibility_price = /** @type {(inputs: Plan_Visibility_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`350€`)
};

const en_plan_visibility_price = /** @type {(inputs: Plan_Visibility_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`350€`)
};

/**
* | output |
* | --- |
* | "350€" |
*
* @param {Plan_Visibility_PriceInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_price = /** @type {((inputs?: Plan_Visibility_PriceInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_PriceInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_price(inputs)
	return en_plan_visibility_price(inputs)
});